import React, { useEffect, useState } from "react";
import { ImPhone } from "react-icons/im";
import { MdEmail } from "react-icons/md";
import { MdNotificationsActive } from "react-icons/md";
import { GoHeart } from "react-icons/go";
import { Link } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import Notification from "../Notification";
import Translator from "../translator";
import axios from "axios";
import { useSelector } from "react-redux";

const NavbarTop = () => {
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const [contactData, setContactData] = useState(null);

  useEffect(() => {
    axios
      .get(`${baseURL}/contact/fetchcontactUs`)
      .then((response) => {
        setContactData(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching contact data:", error);
      });
  }, []);

  // useEffect(() => {
  //     var addScript = document.createElement('script');
  //     addScript.setAttribute(
  //         'src',
  //         '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
  //     );
  //     document.body.appendChild(addScript);
  //     window.googleTranslateElementInit = googleTranslateElementInit;
  // }, []);

  // const googleTranslateElementInit = () => {
  //     new window.google.translate.TranslateElement(
  //         {
  //             pageLanguage: 'en',
  //             includedLanguages: 'en,zh-CN,id,ar,hi', // include this for selected languages
  //             layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
  //             disableAutoTranslation: true, // Disable automatic translation
  //             disableAutoLanguageDetection: true, // Disable automatic language detection
  //             disableSuggestions: true, // Disable suggestions
  //         },
  //         'google_translate_element'
  //     );
  // };

  return (
    <div className="navtop-display">
      <div className="d-flex justify-content-between bg-black py-1 px-2 px-sm-5">
        <div className="d-flex flex-row justify-content-between align-items-center ">
          <div className="navtop_left_text d-flex">
            <p className="primaryColor mx-2 nav-top-text">
              <ImPhone className="accentColor me-1" />
              {/* (704) 555-0127 */}
              <span>{contactData?.phone ? contactData?.phone : ""}</span>
            </p>
            <p className="primaryColor mx-2 nav-top-text">
              <MdEmail className="accentColor me-1 " />
              {/* kenzi.lawson@gmail.com */}
              <span>{contactData?.email ? contactData?.email : ""}</span>
            </p>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div id="google_translate_element"></div>

          {/* <Translator /> */}
          {/* <p className='primaryColor mx-2' >Language</p> */}
          {/* <Notification /> */}
          {/* <Link to='/favourites' ><p data-tooltip-id="fav-heart" className='primaryColor mx-2' ><GoHeart /></p></Link> */}
        </div>
        <ReactTooltip
          style={{ zIndex: 999999 }}
          id="fav-heart"
          place="bottom"
          content="Favourite"
        />
      </div>
    </div>
  );
};

export default NavbarTop;
